import { Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../store/app.states';
import { ComponentBase } from '../../views/component-base';
import { OnDestroy } from '@angular/core';
import { NgwWowService } from 'ngx-wow';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-contribution-list-view',
  templateUrl: './contribution-view.component.html',
  styleUrls: ['./contribution-view.component.scss'],
  host: {
    class: 'w-100'
  }
})
export class ContributionListViewComponent extends ComponentBase implements OnInit, OnDestroy {

  constructor(public store: Store<AppState>,
    private wowService: NgwWowService,
    private router: Router
    ) {
    super();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(event => {
      this.wowService.init();
    });

  }

  ngOnInit() {
    super.ngOnInitBase();

    this.screenWidthChange(this.store, (width: number) => {


    });
  }

  ngOnDestroy() {
    super.ngOnDestroyBase();
  }

  onAddContributionClick()
  {
    this.router.navigate(['add-contribution']);

  }
  onUploadFileClick()
  {
    this.router.navigate(['mapfile']);

  }

}
